'use strict';

var trim = require('trim');

exports.parse = parse;
exports.stringify = stringify;

var empty = '';
var space = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;

function parse(value) {
  var input = trim(String(value || empty));

  if (input === empty) {
    return [];
  }

  return input.split(whiteSpace);
}

function stringify(values) {
  return trim(values.join(space));
}



//////////////////
// WEBPACK FOOTER
// ./~/space-separated-tokens/index.js
// module id = 316
// module chunks = 96961042003272 139266963665775